<div class="document">
  <div class="header">
    <h1>Omega Admin</h1>
  </div>

  <div class="body">
    <router-outlet/>
  </div>
</div>
